import axios, { AxiosResponse } from 'axios';
import { loginData } from '../types/interfaces';

const apiUrls = {
  login: '/v1/login',
};

export const login = async (loginData: loginData) => {
  try {
    const response: AxiosResponse = await axios.post(apiUrls.login, {
      email: loginData.user,
      password: loginData.password,
    });
    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return {
        success: false,
        message: error.response?.data?.message || 'An error occurred',
        status: error.response?.status,
      };
    } else {
      return {
        success: false,
        message: 'An unexpected error occurred',
      };
    }
  }
};

export const confirmUser = async (userId: string, password: string, confirmPassword:string) => {
  try {
    const response: AxiosResponse = await axios.patch(`${apiUrls.login}/users/${userId}`, {
      "password":password,
      "confirmPassword":confirmPassword,
    });
    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return {
        success: false,
        message: error.response?.data?.message || 'An error occurred',
        status: error.response?.status,
      };
    } else {
      return {
        success: false,
        message: 'An unexpected error occurred',
      };
    }
  }
}

export const getUserToConfirmation = async (id: string) => {
  try {
    const response: AxiosResponse = await axios.get(apiUrls.login+`/users/${id}`);
    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return {
        success: false,
        message: error.response?.data?.message || 'An error occurred',
        status: error.response?.status,
      };
    } else {
      return {
        success: false,
        message: 'An unexpected error occurred',
      };
    }
  }
}
